import { useQuery } from "@tanstack/react-query";

import { ListBookActivitiesQueryFilters, UseListBookActivitiesQueryOptions } from "./types";
import { getBookActivitiesService  } from "./service";

export const listBookActivitiesQueryKey = ["book_activity_admin"];

export function useListBookActivitiesQuery(
  filters?: ListBookActivitiesQueryFilters,
  options?: UseListBookActivitiesQueryOptions
) {

  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listBookActivitiesQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getBookActivitiesService(filters),
    ...options,
  });
}
